import { render, staticRenderFns } from "./refundModel.vue?vue&type=template&id=faf35c40"
import script from "./refundModel.vue?vue&type=script&lang=js"
export * from "./refundModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf35c40')) {
      api.createRecord('faf35c40', component.options)
    } else {
      api.reload('faf35c40', component.options)
    }
    module.hot.accept("./refundModel.vue?vue&type=template&id=faf35c40", function () {
      api.rerender('faf35c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/customerManage/refundModel.vue"
export default component.exports